import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Printer } from "lucide-react";
import api from "../../lib/api";
import LanyardCard from "../../components/LanyardCard";
import { Button } from "../../components/ui/button";

export default function BulkPrint() {
  const { locId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get(`/print/location/${locId}`).then((r) => setData(r.data)).catch((e) => setErr(e?.response?.data?.detail || "Failed to load"));
  }, [locId]);

  if (err) return <div className="flex min-h-screen items-center justify-center text-slate-500">{err}</div>;
  if (!data) return <div className="flex min-h-screen items-center justify-center text-slate-400">Preparing cards…</div>;

  return (
    <div className="min-h-screen bg-slate-100">
      <div className="no-print sticky top-0 z-10 flex items-center justify-between border-b border-slate-200 bg-white px-4 py-3 md:px-8">
        <button onClick={() => navigate(-1)} className="inline-flex items-center gap-1 text-sm font-semibold text-slate-500 hover:text-slate-800" data-testid="bulk-back">
          <ArrowLeft className="h-4 w-4" /> Back
        </button>
        <div className="text-sm font-semibold text-slate-500">{data.location.name} · {data.cards.length} cards</div>
        <Button onClick={() => window.print()} data-testid="bulk-print-button" className="bg-[#4338CA] hover:bg-[#3730A3]">
          <Printer className="mr-1 h-4 w-4" /> Print all
        </Button>
      </div>

      {data.cards.length === 0 ? (
        <div className="flex min-h-[60vh] items-center justify-center text-slate-400">No active employees with a live QR identity at this location.</div>
      ) : (
        <div className="mx-auto max-w-6xl p-6">
          <div className="flex flex-wrap justify-center gap-6 print-sheet" data-testid="bulk-grid">
            {data.cards.map((c) => (
              <div key={c.id} style={{ breakInside: "avoid" }}>
                <LanyardCard displayName={(c.name || "").split(" ")[0]} jobTitle={c.job_title} photoUrl={c.photo_url}
                  qrPng={c.png} orgName={data.organization?.name} orgLogo={data.organization?.logo_url}
                  opts={data.template} testId={`bulk-card-${c.id}`} />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
